import { render } from "./MultipleResponse.vue?vue&type=template&id=1da27868&scoped=true"
import script from "./MultipleResponse.vue?vue&type=script&lang=js"
export * from "./MultipleResponse.vue?vue&type=script&lang=js"

import "./MultipleResponse.vue?vue&type=style&index=0&id=1da27868&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da27868"]])

export default __exports__